import { render, staticRenderFns } from "./engineDesc.vue?vue&type=template&id=ed81717e&scoped=true&"
import script from "./engineDesc.vue?vue&type=script&lang=ts&"
export * from "./engineDesc.vue?vue&type=script&lang=ts&"
import style0 from "./engineDesc.vue?vue&type=style&index=0&id=ed81717e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed81717e",
  null
  
)

export default component.exports